"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

type Props = {
	skill: string;
	hasData: boolean;
	locale: string;
};

/**
 * Fires `intel_module_viewed` once on mount for the T4 weekly-trend block on
 * /jobs/skill/[slug] (docs/plans/labor-market-intelligence-wedge-2026-08-20.md
 * — the north-star Intelligence->Action rate needs this event so click-through
 * to jobs can be measured against surface views). Mirrors
 * CompanyProfileViewBeacon (src/components/companies/company-profile-view-beacon.tsx):
 * the page is ISR, so a server-side capture would only fire on cache
 * revalidation, not per visitor. Renders null.
 */
export function SkillTrendModuleViewBeacon({ skill, hasData, locale }: Props) {
	const posthog = usePostHog();
	useEffect(() => {
		posthog?.capture("intel_module_viewed", {
			surface: "skill_weekly_trend",
			skill,
			has_data: hasData,
			locale,
		});
	}, [posthog, skill, hasData, locale]);
	return null;
}
